import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useLanguage } from '../context/LanguageContext';
import { createTopup, createTopupStripe, getBalance, getSiteConfig } from '../utils/api';

const CRYPTO_OPTIONS = [
  { id: 'BTC', label: 'Bitcoin', icon: <svg width="20" height="20" viewBox="0 0 32 32" fill="none"><circle cx="16" cy="16" r="16" fill="#F7931A"/><path d="M22.5 14.2c.3-2-1.2-3.1-3.3-3.8l.7-2.7-1.7-.4-.7 2.6c-.4-.1-.9-.2-1.4-.3l.7-2.7-1.7-.4-.7 2.7c-.4-.1-.7-.2-1-.2l-2.3-.6-.4 1.8s1.2.3 1.2.3c.7.2.8.6.8 1l-.8 3.3c0 .1.1.1.1.1l-.1 0-1.2 4.6c-.1.2-.3.6-.8.4 0 0-1.2-.3-1.2-.3l-.8 1.9 2.2.5c.4.1.8.2 1.2.3l-.7 2.8 1.7.4.7-2.7c.5.1.9.2 1.4.3l-.7 2.7 1.7.4.7-2.8c2.9.5 5.1.3 6-2.3.7-2.1 0-3.3-1.5-4.1 1.1-.3 1.9-1 2.1-2.5zm-3.8 5.3c-.5 2.1-4.1 1-5.3.7l.9-3.8c1.2.3 4.9.9 4.4 3.1zm.5-5.4c-.5 1.9-3.5.9-4.4.7l.8-3.4c1 .2 4.1.7 3.6 2.7z" fill="white"/></svg> },
  { id: 'ETH', label: 'Ethereum', icon: <svg width="20" height="20" viewBox="0 0 32 32" fill="none"><circle cx="16" cy="16" r="16" fill="#627EEA"/><path d="M16.5 4v8.9l7.5 3.3L16.5 4z" fill="white" fillOpacity=".6"/><path d="M16.5 4L9 16.2l7.5-3.3V4z" fill="white"/><path d="M16.5 21.9v6.1l7.5-10.4-7.5 4.3z" fill="white" fillOpacity=".6"/><path d="M16.5 28v-6.1L9 17.6l7.5 10.4z" fill="white"/></svg> },
  { id: 'LTC', label: 'Litecoin', icon: <svg width="20" height="20" viewBox="0 0 32 32" fill="none"><circle cx="16" cy="16" r="16" fill="#345D9D"/><path d="M10.5 23.5h11.3l.9-3.2h-7l1.6-5.7 3-1.1.6-2.2-3 1.1L19.6 5h-3.8l-2.3 8.4-3 1.1-.6 2.2 3-1.1-1.4 4.7v3.2z" fill="white"/></svg> },
  { id: 'USDT_ERC20', label: 'USDT ERC20', icon: <svg width="20" height="20" viewBox="0 0 32 32" fill="none"><circle cx="16" cy="16" r="16" fill="#26A17B"/><path d="M17.9 17.1v0c-.1 0-.7.1-2 .1-1 0-1.7 0-1.9-.1v0c-3.8-.2-6.6-.9-6.6-1.7s2.8-1.5 6.6-1.7v2.7c.3 0 1 .1 2 .1 1.2 0 1.7-.1 1.9-.1v-2.7c3.8.2 6.6.9 6.6 1.7s-2.8 1.6-6.6 1.7zm0-3.7V11h5.3V8h-14.5v3h5.3v2.4c-4.3.2-7.5 1.1-7.5 2.2s3.2 2 7.5 2.2v7.9h3.9v-7.9c4.2-.2 7.5-1.1 7.5-2.2s-3.2-2-7.5-2.2z" fill="white"/></svg> },
  { id: 'USDC_ERC20', label: 'USDC ERC20', icon: <svg width="20" height="20" viewBox="0 0 32 32" fill="none"><circle cx="16" cy="16" r="16" fill="#2775CA"/><path d="M20.6 18.5c0-2.1-1.3-2.8-3.8-3.1-1.8-.3-2.2-.7-2.2-1.4s.6-1.2 1.8-1.2c1.1 0 1.7.4 2 1.2h1.8c-.3-1.5-1.4-2.5-3-2.8V9.5h-2v1.7c-1.8.3-2.9 1.5-2.9 3 0 2 1.2 2.7 3.7 3.1 1.8.3 2.3.7 2.3 1.5s-.8 1.3-1.9 1.3c-1.4 0-2-.6-2.2-1.5h-1.8c.2 1.7 1.3 2.7 3.1 3v1.8h2v-1.8c1.8-.3 3.1-1.4 3.1-3.1z" fill="white"/></svg> },
  { id: 'USDT_BEP20', label: 'USDT BEP20', icon: <svg width="20" height="20" viewBox="0 0 32 32" fill="none"><circle cx="16" cy="16" r="16" fill="#F0B90B"/><path d="M17.9 17.1v0c-.1 0-.7.1-2 .1-1 0-1.7 0-1.9-.1v0c-3.8-.2-6.6-.9-6.6-1.7s2.8-1.5 6.6-1.7v2.7c.3 0 1 .1 2 .1 1.2 0 1.7-.1 1.9-.1v-2.7c3.8.2 6.6.9 6.6 1.7s-2.8 1.6-6.6 1.7zm0-3.7V11h5.3V8h-14.5v3h5.3v2.4c-4.3.2-7.5 1.1-7.5 2.2s3.2 2 7.5 2.2v7.9h3.9v-7.9c4.2-.2 7.5-1.1 7.5-2.2s-3.2-2-7.5-2.2z" fill="white"/></svg> }
];

const AMOUNT_PRESETS = [10, 25, 50, 100, 250, 500];

const TopUp = () => {
  const { user } = useAuth();
  const { t } = useLanguage();
  const navigate = useNavigate();
  const [amount, setAmount] = useState('');
  const [paymentMethod, setPaymentMethod] = useState('crypto');
  const [selectedCrypto, setSelectedCrypto] = useState('LTC');
  const [loading, setLoading] = useState(false);
  const [balance, setBalance] = useState(null);
  const [siteConfig, setSiteConfig] = useState(null);
  const [coupon, setCoupon] = useState('');
  const [couponExpanded, setCouponExpanded] = useState(false);
  const [termsAccepted, setTermsAccepted] = useState(false);

  useEffect(() => { if (!user) navigate('/'); }, [user, navigate]);
  useEffect(() => {
    if (user) {
      getBalance().then(d => setBalance(d.balance ?? user.balance ?? 0)).catch(() => setBalance(user.balance ?? 0));
      getSiteConfig().then(c => setSiteConfig(c)).catch(() => {});
    }
  }, [user]);

  const isCardDisabled = siteConfig?.paymentMethods?.stripe?.enabled === false;

  const handleTopUp = async () => {
    if (!amount || parseFloat(amount) < 1) return;
    setLoading(true);
    try {
      if (paymentMethod === 'fiat') {
        const result = await createTopupStripe({ amount: parseFloat(amount), coupon: coupon || undefined });
        if (result.success && result.stripeUrl) window.location.href = result.stripeUrl;
      } else {
        const result = await createTopup({ amount: parseFloat(amount), cryptoType: selectedCrypto, coupon: coupon || undefined });
        if (result.success && result.orderId) window.open(`/checkout/${result.orderId}`, '_blank');
      }
    } catch (err) { alert(err.message || 'Failed to create top-up'); }
    finally { setLoading(false); }
  };

  if (!user) return null;

  const isBanned = user.banned || user.blocked;

  return (
    <main className="main-content">
      <div className="topup-page">
        <div className="topup-header animate-drop">
          <h1>Top Up Balance</h1>
          <p>Add funds to your account to purchase boosts</p>
        </div>

        {isBanned && (
          <div className="banned-banner animate-drop">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><line x1="4.93" y1="4.93" x2="19.07" y2="19.07"/></svg>
            <div><strong>Account Banned</strong><p>Your account has been suspended. All purchases and features are disabled.</p></div>
          </div>
        )}

        <div className="topup-layout animate-drop delay-1">
          <div className="topup-main">
            <div className="dash-card topup-card">
              <div className="topup-card-icon-row">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="var(--green-primary)" strokeWidth="2"><rect x="2" y="5" width="20" height="14" rx="2"/><path d="M2 10h20"/></svg>
              </div>

              {/* Amount */}
              <div className="form-group">
                <label className="form-label">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{verticalAlign:'middle',marginRight:4}}><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>
                  Amount (USD)
                </label>
                <div className="topup-amount-input-wrap">
                  <span className="topup-dollar-sign">$</span>
                  <input
                    type="number"
                    className="form-input topup-amount-input"
                    placeholder="Enter amount"
                    value={amount}
                    onChange={e => setAmount(e.target.value)}
                    min="1"
                    disabled={isBanned}
                  />
                </div>
                <div className="topup-presets">
                  {AMOUNT_PRESETS.map(a => (
                    <button key={a} className={`topup-preset-btn ${parseFloat(amount) === a ? 'selected' : ''}`} onClick={() => setAmount(String(a))} disabled={isBanned}>${a}</button>
                  ))}
                </div>
                {amount && parseFloat(amount) > 0 && parseFloat(amount) < 1 && (
                  <div style={{color:'#ef4444',fontSize:'0.8rem',marginTop:'0.5rem',fontWeight:500}}>Minimum top up is $1.00</div>
                )}
              </div>

              {/* Payment Method */}
              <div className="payment-method-toggle">
                <label className="form-label">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{verticalAlign:'middle',marginRight:4}}><rect x="1" y="4" width="22" height="16" rx="2" ry="2"/><line x1="1" y1="10" x2="23" y2="10"/></svg>
                  Payment Method
                </label>
                <div className="payment-method-buttons-v2">
                  <button className={`pm-btn-v2 ${paymentMethod === 'fiat' ? 'selected' : ''} ${isCardDisabled ? 'pm-disabled' : ''}`} onClick={() => !isCardDisabled && setPaymentMethod('fiat')} disabled={isBanned || isCardDisabled}>
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="1" y="4" width="22" height="16" rx="2" ry="2"/><line x1="1" y1="10" x2="23" y2="10"/></svg>
                    <span>Card</span>
                  </button>
                  <button className={`pm-btn-v2 ${paymentMethod === 'crypto' ? 'selected' : ''}`} onClick={() => setPaymentMethod('crypto')} disabled={isBanned}>
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><path d="M9.5 8h5a2.5 2.5 0 010 5h-5V8z"/><path d="M9.5 13h5.5a2.5 2.5 0 010 5H9.5V13z"/></svg>
                    <span>Crypto</span>
                  </button>
                </div>
              </div>

              {/* Crypto selector - default LTC, collapsed */}
              {paymentMethod === 'crypto' && (
                <div className="crypto-selector">
                  <label className="form-label">Select Cryptocurrency</label>
                  <div className="crypto-options">
                    {CRYPTO_OPTIONS.map(c => (
                      <button key={c.id} className={`crypto-option ${selectedCrypto === c.id ? 'selected' : ''}`} onClick={() => setSelectedCrypto(c.id)} disabled={isBanned}>
                        <span className="crypto-option-icon">{c.icon}</span>
                        <span className="crypto-option-label">{c.label}</span>
                      </button>
                    ))}
                  </div>
                </div>
              )}

              {/* Coupon */}
              <div className="form-group">
                <button type="button" className={`coupon-expand-btn-v2 ${couponExpanded ? 'open' : ''}`} onClick={() => setCouponExpanded(!couponExpanded)}>
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="9 18 15 12 9 6"/></svg>
                  Have a coupon?
                </button>
                {couponExpanded && (
                  <div className="coupon-row">
                    <input type="text" className="form-input" placeholder="Enter coupon code" value={coupon} onChange={e => setCoupon(e.target.value)} disabled={isBanned} />
                  </div>
                )}
              </div>

              {/* Terms */}
              <div className="checkbox-row" onClick={() => !isBanned && setTermsAccepted(!termsAccepted)}>
                <div className={`checkbox ${termsAccepted ? 'checked' : ''}`}>{termsAccepted && (<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3"><polyline points="20 6 9 17 4 12"/></svg>)}</div>
                <span className="checkbox-label">By purchasing, you agree to the <a href="/terms" target="_blank" rel="noopener noreferrer" onClick={(e) => e.stopPropagation()}>terms of service</a>.</span>
              </div>

              {/* Payment Summary & Button */}
              <div className="topup-summary" style={{ marginTop: '1.25rem' }}>
                <div className="topup-summary-row">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>
                  <span>Payment Summary</span>
                  <span className="topup-summary-amount">{amount ? `$${parseFloat(amount).toFixed(2)}` : ''}</span>
                </div>
                <button className="btn btn-primary topup-pay-btn" onClick={handleTopUp} disabled={isBanned || !amount || parseFloat(amount) < 1 || !termsAccepted || loading}>
                  {loading ? <span className="loading-spinner" /> : <>Proceed to Payment <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg></>}
                </button>
              </div>

              {/* Info notice */}
              <div className="topup-info-notice">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg>
                <div>
                  <strong>Payment Processing</strong>
                  <p>Funds are typically added to your account instantly after payment confirmation. Cryptocurrency payments may take longer depending on network conditions.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default TopUp;
